import React from "react";
import Dropdown from "../common/dropdown/Dropdown";
import {useSelector} from "react-redux";
import {toCamelCase} from "../Utility";

const ActionDropdown = ({
                            row,
                            view = true,
                            edit = true,
                            customUrl = false,
                            owners,
                            getDue,
                            orders,
                            assign,
                            assignEmployee,
                            history,
                            purchase,
                            onDelete,
                            onUpdate,
                            onReset,
                            addDuplicate,
                            formData = {},
                            onMarkAsPaid,
                            restricted = []
                        }) => {
    const {id, customerId, name, fName, lName} = row;

    const Name = toCamelCase(name);
    const fullName = toCamelCase(
        [fName, lName].filter(Boolean).join(' ')
    );

    const {selectedRole} = useSelector((state) => state.auth);
    const userRole = selectedRole ? `${selectedRole.scope}${selectedRole.role}` : "Customer";

    const actions = [];

    if (view) {
        actions.push({
            key: 'a',
            label: 'View',
            icon: 'eye',
            link: id
        });
    }

    //Only Edit purchase when due is greater than 0
    if (edit && !(row?.dueAmount === 0 && row.purchaseDate)) {
        actions.push({
            key: 'b',
            label: customUrl ? `Update` : `Edit`,
            icon: 'edit',
            link: customUrl ? `/customer/${customerId}/editDiscount/${id}` : `${id}/edit`
        });
    }

    //Only Delete purchase when due is not clear
    //Only Delete when not generated by system
    if (onDelete && row?.systemGen !== true && !(row?.dueAmount === 0 && row.purchaseDate)) {
        actions.push({
            id: id,
            key: 'c',
            label: "Delete",
            icon: "delete",
            confirm: true,
            confirmMessage: "Are you sure you want to delete?",
            clickHandler: (item) => onDelete(item.id),
        });
    }
    if (onUpdate) {
        actions.push({
            row: row,
            key: 'd',
            status: row?.status,
            label: "Assign",
            icon: "update",
            form: true,
            formTitle: "Assign",
            formData: formData,
            clickHandler: (data) => onUpdate(data),
        });
    }
    if (owners) {
        actions.push({
            key: 'e',
            label: 'Manage Owners',
            icon: 'user',
            link: `${id}/manage-owners`
        });
    }
    if (orders) {
        actions.push({
            key: 'g',
            label: 'View Orders',
            icon: 'calendar-day',
            link: `${id}/customerOrder`
        });
    }
    if (getDue) {
        actions.push({
            key: 'h',
            label: 'Get Dues',
            icon: 'money',
            link: `${id}/getDue`
        });
    }
    if (history) {
        actions.push({
            key: 'i',
            label: 'History',
            icon: 'receipt',
            link: `${id}/history`
        });
    }
    if (purchase) {
        actions.push({
            key: 'j',
            label: 'View',
            icon: 'eye',
            link: `${id}/purchase`
        });
    }
    if (assign) {
        actions.push({
            key: 'k',
            label: 'Manage tag',
            icon: 'assign',
            link: `${id}/assign/${Name}`
        });
    }
    if (assignEmployee) {
        actions.push({
            key: 'L',
            label: 'Assign Employee',
            icon: 'assign',
            link: `${id}/assignEmployee/${fullName}`
        });
    }
    if (onReset) {
        actions.push({
            id: id,
            key: 'm',
            label: 'Reset',
            icon: 'reset',
            confirm: true,
            confirmMessage: "Are you sure you want to reset?",
            clickHandler: (item) => onReset(item.id),
        });
    }
    if (addDuplicate) {
        actions.push({
            key: 'n',
            label: 'Duplicate',
            icon: 'assign',
            link: `${id}/add`
        });
    }
    if (onMarkAsPaid && (row?.Status === 0 || row?.Status === undefined)) {
        actions.push({
            key: 'o',
            label: 'Mark as Paid',
            icon: 'markAsPaid',
            confirm: true,
            confirmMessage: "Are you sure you want to mark this invoice as paid?",
            clickHandler: (item) => onMarkAsPaid(id),
        });
    }

    const dropdownList = actions.map(action => ({
        ...action,
        link: action.link || undefined,
        clickHandler: action.clickHandler || undefined
    }));

    // Filter actions based on user role and restricted permissions
    const filteredActions = dropdownList.filter(action => {
        if (!restricted.length) return true; // No restrictions, show all actions
        return !restricted.some(restriction =>
            restriction[userRole] && restriction[userRole].includes(action.key)
        );
    });

    return (
        <div onClick={(e) => e.stopPropagation()}>
            <Dropdown
                className="btn-sm bg-transparent ms-auto"
                buttonIconSize="sm"
                buttonIcon="dots"
                list={filteredActions}
                align="end"
            />
        </div>
    );
}

export default ActionDropdown;
